import { createSelector } from "reselect";

const selectFleetManagementState = (state) => state.fleetManagement;

const selectFailedCertificateDusns = () =>
  createSelector(
    selectFleetManagementState,
    (fleetManagementState) => fleetManagementState.failedCertificateDusns
  );

const selectDevices = () =>
  createSelector(
    selectFleetManagementState,
    (fleetManagementState) => fleetManagementState.devices
  );

const selectDeviceByCodentify = (codentify) =>
  createSelector(selectFleetManagementState, (fleetManagementState) =>
    codentify ? fleetManagementState.devices?.find((el) => el?.codentify === codentify) : null
  );

const selectDeviceByDusn = (dusn) =>
  createSelector(selectFleetManagementState, (fleetManagementState) =>
    dusn ? fleetManagementState.devices?.find((el) => el?.dusn === dusn) : null
  );

const selectDeviceKitList = () =>
  createSelector(
    selectFleetManagementState,
    (fleetManagementState) => fleetManagementState?.deviceKitList
  );

export { selectFailedCertificateDusns, selectDevices, selectDeviceByCodentify, selectDeviceByDusn, selectDeviceKitList };
